import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class ScrollTo extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {...{
      offset: 0
    }, ...this._options}
    this._offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
  }

  mount () {
    let hash = this._elem.getAttribute('href') ? this._elem.getAttribute('href') : '#'

    if (!this._options.target) {
      this._options = {
        on: "click",
        target: hash,
        preventDefault: true,
        offset: 0
      }
    }

    if (this._options.length) {
      for (let option of this._options) {
        this._optionLogic(option)

        if (window.location.hash === hash) {
          this._eventLogic(option)
        }
      }
    } else {
      this._optionLogic(this._options)

      if (window.location.hash === hash) {
        this._eventLogic(this._options)
      }
    }
  } 

  _optionLogic(option) {
    this._elem.addEventListener(option.on, async e => {
      if (option.onlyThisElem && e.target !== this._elem) {
        return false
      }
      
      if (option.preventDefault) {
        e.preventDefault()
      }

      this._eventLogic(option)
   
    }, option.preventDefault ? { passive: false } : { passive: true })
  }

  _eventLogic (option) {
    let target = document.querySelector(option.target)
    let scrolltToTop = window.pageYOffset + target.getBoundingClientRect().top - this._offset - this._options.offset

    console.log(scrolltToTop)

    window.scrollTo({
      top: scrolltToTop,
      behavior: 'smooth'
    })
  }
}